import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import CoveragePaths from '../components/CoveragePaths';
import Carriers from '../components/Carriers';
import ServiceAreas from '../components/ServiceAreas';
import About from '../components/About';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <Carriers />
      <CoveragePaths />
      <Services />
      <ServiceAreas />
      <About />
      <Footer />
    </div>
  );
};

export default Home;
